import { Box, MenuItem, Select, Tab, Tabs } from '@mui/material';
import RequestListTable from '@src/components/schedule/request-list/table';
import Button from '@src/components/ui/atoms/button';
import placeApi from '@src/services/api/place';
import { RequestBookingListType } from '@src/types/booking';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div``;

const InfoWrap = styled.div`
  display: flex;
  justify-content: end;
  margin: 10px 0;
`;

interface TabPanelProps {
  children?: React.ReactNode;
  value: TabType;
  selected: TabType;
}
function TabPanel(props: TabPanelProps) {
  const { children, selected, value } = props;

  return (
    <div
      role="tabpanel"
      hidden={selected !== value}
      id={`simple-tabpanel-${value}`}
      aria-labelledby={`simple-tab-${value}`}
    >
      {value === selected && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const TAB_LIST = [
  {
    key: 0,
    label: '신청',
  },
  {
    label: '승인',
    key: 1,
  },
  {
    label: '거절',
    key: 2,
  },
] as const;

const STATE_LIST = [
  {
    label: '요청전',
    key: 2,
  },
  {
    key: 1,
    label: '성공',
  },
  {
    label: '실패',
    key: 0,
  },
] as const;

type StateKeyType = (typeof STATE_LIST)[number]['key'];

type TabType = (typeof TAB_LIST)[number]['key'];

export default function AdminRequestList() {
  const [requestAllList, setRequestAllList] = useState<RequestBookingListType[]>();
  const selectedRequest = useRef<number[]>([]);
  const [tab, setTab] = useState<TabType>(0);
  const [requestState, setRequestState] = useState<StateKeyType | null>(0);

  const requestList = useMemo(() => {
    const tabList = requestAllList?.filter(request => request.confirm == tab);
    if (requestState === null) {
      return tabList;
    }
    return tabList?.filter(request => {
      const response = request.response && JSON.parse(request.response);
      const result = response ? !response.data.error : null;
      if (requestState == 2) {
        return result === null;
      } else if (requestState == 1) {
        return result;
      } else {
        return !result;
      }
    });
  }, [requestAllList, requestState, tab]);

  async function getScheduleList() {
    const { data } = await placeApi.getAdminRequestList();
    setRequestAllList(data);
  }
  useEffect(() => {
    getScheduleList();
  }, []);

  const onSelectRequest = useCallback((list: number[]) => {
    selectedRequest.current = list;
  }, []);

  const handleRequestState = (newValue: StateKeyType) => {
    setRequestState(newValue);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: TabType) => {
    setTab(newValue);
  };

  const handleConfirm = async (state: TabType) => {
    if (selectedRequest.current.length) {
      const { code, data } = await placeApi.confirmAdminRequestList(selectedRequest.current, state);
      if (code === 200) {
        setRequestAllList(data);
        selectedRequest.current = [];
        alert('Success');
      } else {
        alert('Fail');
      }
    }
  };

  useEffect(() => {
    setRequestState(null);
  }, [tab]);

  return (
    <Container>
      <div>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tab} onChange={handleTabChange} aria-label="lab API tabs example">
            {TAB_LIST.map(tab => (
              <Tab key={tab.key} value={tab.key} label={tab.label} />
            ))}
          </Tabs>
        </Box>
      </div>
      <Box sx={{ margin: '10px 0', width: 200 }}>
        <Select
          value={requestState}
          onChange={event => handleRequestState(event.target.value as StateKeyType)}
          size="small"
          fullWidth
        >
          {STATE_LIST?.map(state => (
            <MenuItem key={state.key} value={state.key}>
              {state.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <InfoWrap>
        <Button onClick={() => handleConfirm(1)}>Confirm</Button>
        <Button onClick={() => handleConfirm(2)}>Reject</Button>
      </InfoWrap>
      <RequestListTable list={requestList || []} onSelectListChange={onSelectRequest} />
    </Container>
  );
}
